var map = {
	"./1AGN.png": 12735,
	"./2AGN.png": 31661,
	"components/Catalog/AGN/img/allDoor/Gold/1AGN.png": 12735,
	"components/Catalog/AGN/img/allDoor/Gold/2AGN.png": 31661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65896;